import { LazyLoadImage } from "react-lazy-load-image-component";
import heroOffice from "../../assets/img/hero/heroprofile2.png";

export default function Hero() {
    return (
        <div>
            <LazyLoadImage
                src={heroOffice}
                alt="offers"
                effect="blur"
                className="w-full h-full object-cover"
                wrapperProps={{
                    style: { transitionDelay: '1s' },
                }}
            />
        </div >
    )
}